export class BusinessRoleInput {
    public name: string = '';
}
